import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import HeaderPaneProps from './HeaderPaneProps';
import { observer } from 'mobx-react';
import { ActivityFeed } from 'owa-activity-feed';
import strings from 'owa-strings/owa-common-strings';
import popoutReadingPane from 'owa-popout-utils/lib/utils/popoutReadingPane';

const activityFeedActions = {
    openMail: popoutReadingPane,
};

@observer
export default class ActivityFeedPane extends React.Component<HeaderPaneProps, {}> {
    constructor(props: HeaderPaneProps) {
        super(props);
    }

    render() {
        return (
            <HeaderFlexPane
                title={strings.activityFeedTitle}
                content={<ActivityFeed actions={activityFeedActions} />}
                onDismiss={this.props.onDismiss}
            />
        );
    }
}
